/**
 * a2-chrome.js — redesign header / menu / footer behaviour (homepage-handoff 04, 02 §11).
 * Loaded by layout/theme.liquid only where the redesign chrome is on (new homepage template, or site-wide via
 * Theme settings › A2 redesign). The menu itself keeps the theme's behaviour (hover / click, drawer focus trap);
 * this adds analytics, the footer's country selector submit, and the newsletter success event.
 */
(function () {
  'use strict';
  if (window.A2Chrome) return;
  window.A2Chrome = true;

  // The theme's scripts size the sticky bar from window.stickyHeaderHeight (60 in layout/theme.liquid); the redesign
  // bar stays 88 / 64px tall when it sticks (a2-header.css sets the matching --header-sticky-height).
  var mqMobileBar = window.matchMedia('(max-width: 1023px)');
  function setStickyHeight() { if (window.stickyHeaderHeight) window.stickyHeaderHeight = mqMobileBar.matches ? 64 : 88; }
  setStickyHeight();
  if (mqMobileBar.addEventListener) mqMobileBar.addEventListener('change', setStickyHeight);

  function track(name, data) {
    data = Object.assign({ template: (document.body.className.match(/template-([\w-]+)/) || [])[1] || '' }, data || {});
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }

  // Menu: nav_open {surface: mega|drawer}, nav_click {label, level}.
  var megaOpen = false;
  document.addEventListener('mouseover', function (e) {
    var item = e.target.closest && e.target.closest('.site-header [data-nav-item][aria-haspopup="true"]');
    if (item && !megaOpen) { megaOpen = true; track('nav_open', { surface: 'mega', label: (item.querySelector('.navtext') || {}).textContent || '' }); }
  });
  document.addEventListener('mouseout', function (e) {
    var item = e.target.closest && e.target.closest('.site-header [data-nav-item]');
    if (item && !item.contains(e.relatedTarget)) megaOpen = false;
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-drawer-toggle][aria-controls="nav-drawer"]');
    if (t && !document.body.classList.contains('js-drawer-open')) track('nav_open', { surface: 'drawer' });
    var a = e.target.closest && e.target.closest('.site-header a.navlink, #nav-drawer a.mobile-navlink');
    if (a) {
      var level = /navlink--toplevel|mobile-navlink--level-1/.test(a.className) ? 1 : /navlink--child|level-2/.test(a.className) ? 2 : 3;
      track('nav_click', { label: a.textContent.trim(), level: level });
    }
  });

  // Footer: country / currency selector submits on change; newsletter success (Shopify redirects back with
  // ?customer_posted=true after a sign-up, and the section shows its success message).
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-a2-loc] select');
    if (s) s.form.submit();
  });
  // Footer region selector = the Orbe app's (it can also send the shopper to the other store). Preferred: an Orbe
  // "Country Selector" block positioned into .a2-footer__bar, which opens its country list directly. Otherwise the
  // footer button opens the same pop-up as the header's currency button. Orbe injects after load, so look for a
  // few seconds; with neither, the store's own country list (the form) stays.
  function linkOrbe() {
    var trigger = document.querySelector('[data-a2-orbe]');
    if (!trigger) return;
    var tries = 0;
    (function find() {
      var form = document.querySelector('[data-a2-loc]');
      if (document.querySelector('.a2-footer .md-orbe-selector__container')) {
        if (form) form.hidden = true;
        trigger.remove();
        return;
      }
      var orbe = document.querySelector('.site-header .md-orbe-custom-selector') || document.querySelector('.md-orbe-custom-selector');
      if (!orbe || tries < 8) { if (++tries < 40) { setTimeout(find, 250); return; } if (!orbe) return; }
      var label = orbe.querySelector('.md-orbe-country-selector-span');
      var text = trigger.querySelector('[data-a2-orbe-text]');
      if (label && text && label.textContent.trim()) text.textContent = label.textContent.trim();
      if (form) form.hidden = true;
      trigger.hidden = false;
      trigger.addEventListener('click', function () { track('footer_region_open', {}); orbe.click(); });
    })();
  }
  linkOrbe();

  function onLoad() {
    if (/[?&]customer_posted=true/.test(location.search) && document.querySelector('[data-a2-newsletter]')) {
      track('hp_newsletter_submit', {});
      var f = document.querySelector('[data-a2-footer]');
      if (f && location.hash.indexOf('A2FooterNewsletter') > -1) f.scrollIntoView({ block: 'center' });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad); else onLoad();
})();
